// ABOUTME: The image style a node-info widget config may set, and its parser.
// ABOUTME: Shared by the widget and its loading skeletons.

import { CSSProperties } from 'react';

const IMAGE_STYLE_KEYS = [
    'width',
    'height',
    'maxWidth',
    'maxHeight',
    'objectFit',
    'borderRadius',
] as const;

// The few style keys a widget config may set. Narrower than CSSProperties on purpose: these are
// also spread onto the DS `Img`, whose props are system props, and the full CSS surface would
// collide with the DOM attributes of the same name (`translate`, `color`, …).
export type ImageStyle = Pick<CSSProperties, (typeof IMAGE_STYLE_KEYS)[number]>;

// Keeps only the known string-valued keys of the configured image style so arbitrary config
// cannot inject other inline styles.
export const parseImageStyle = (raw: unknown): ImageStyle => {
    if (!raw || typeof raw !== 'object') return {};
    const source = raw as Record<string, unknown>;
    return IMAGE_STYLE_KEYS.reduce<ImageStyle>((acc, key) => {
        const value = source[key];
        return typeof value === 'string' && value.trim() !== '' ? { ...acc, [key]: value } : acc;
    }, {});
};
